import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconMainsonetteRoom = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconMainsonetteRoom",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M6.5 14.5h11v2h-11zM8 12h8v2H8zm1.5-2h5v1.5h-5zM5 17h14v2H5z"
  }), _jsx("path", {
    d: "M10.16 5.03a.5.5 0 0 0-.56.17l-4.5 6a.5.5 0 0 0-.1.3v5h1v-4.83l.5-.67v3h1V9.67L8 9v2.5h1V7.67L9.5 7v2.5h1v-4a.5.5 0 0 0-.34-.47m3.68 0a.5.5 0 0 1 .56.17l4.5 6q.1.14.1.3v5h-1v-4.83l-.5-.67v3h-1V9.67L16 9v2.5h-1V7.67L14.5 7v2.5h-1v-4c0-.22.14-.4.34-.47"
  })]
}));
IconMainsonetteRoom.displayName = 'IconMainsonetteRoom';